
<div class="bottom-sheet">
    <div> {{ 'What is the date of completion of the work?' | translate }} </div>
    <button mat-raised-button type="button" color="warn" (click)="prev()">{{ "Previously" | translate }}</button>
    <button mat-raised-button class="change" #btnFocus cdkFocusInitial type="submit" color="primary" (click)="today()">{{ "Today" | translate }}</button>
</div>